import { Vault } from '@/features/vaults/types';
import { usdcTokenAddress } from '@/features/vaults/constants/vaults/mezo/tokens/usdcTokenAddress';
import { Hash } from '@/shared/types/Hash';

export const ethereumMezoStableVaultId = 'ethereum-mezo-stable-vault';

export const ethereumMezoStableVaultAddress: Hash = '0x7207595E4c18a9A829B9dc868F11F3ADd8FCF626';

export const ethereumMezoStableVault: Vault = {
  id: ethereumMezoStableVaultId,
  type: 'core-vault',
  name: 'Mezo Stable Vault',
  description:
    "Mezo's flagship stablecoin yield vault. Deposit MUSD, USDC, or USDT to access delta-neutral yield strategies spanning basis trades, funding rate arbitrage, stable pair liquidity on DEXes across EVM chains, and borrow/lend opportunities.\n" +
    '<br/><br/>' +
    'Curator: Perseus Digital — Quantitative trading firm specializing in delta-neutral strategies across CeFi and DeFi. Expertise in basis trading, funding rate arbitrage, and other market-neutral liquidity strategies.',
  category: 'core-vault',
  address: ethereumMezoStableVaultAddress,
  curators: ['mezo', 'perseus'],
  operator: [],
  points: [{ entity: 'mellow', startTimestamp: 1760967575 }],
  network: 'ethereum',
  networks: [
    {
      network: 'ethereum',
      vaultAddress: '0x7207595E4c18a9A829B9dc868F11F3ADd8FCF626',
    },
  ],
  baseToken: usdcTokenAddress,
  lpTokenSymbol: 'msvUSD',
  lpTokenDecimals: 6,
  oracleUpdateInterval: BigInt(86400),
  redeemHandlingInterval: BigInt(3600),
  allocations: {
    showAllocationsTab: true,
  },
  prioritizedQueues: [
    '0x97222aB82045dC002f94B68ec0A0e0b423d235E5', // usdc
    '0x0c2a47d52efb0bfbDda1F51cd4Eb97857441fEf6', // usdt
    '0x41c5deFe909d5326c7C9Bac309F10826118947a7', // musd
  ],
  isInstantDeposit: true,
  predictedApy: {
    value: 37,
    type: 'APY',
  },
  isWithdrawDisabled: true,
  archived: true,
  deposit: {
    disabled: true,
  },
};
